import type { UserReferenceDto } from "@/lib/api";
import type { Owner } from "@/types/owner.types";
import { withImageVersion } from "@/utils/with-image-version/with-image-version";

export function toOwner(dto?: UserReferenceDto): Owner | undefined {
	if (!dto) return undefined;
	return {
		remoteId: dto.remoteId,
		userName: dto.userName,
		displayName: dto.displayName,
		imageUrl: withImageVersion(dto.imageUrl),
	};
}
